import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
import { useLaunchCountdown } from '../hooks/useLaunchCountdown';
export function UrgencyBanner() {
  const {
    timeLeft,
    spotsTaken
  } = useLaunchCountdown();
  const format = (value: number) => value.toString().padStart(2, '0');
  const time = `${format(timeLeft.h)}:${format(timeLeft.m)}:${format(timeLeft.s)}`;
  return <div className="sticky top-0 z-50 w-full border-b border-brand-gold/50 bg-brand-purpleDark text-white shadow-md" data-id="element-271" data-mp="2wbrtpziu4mi7">
      <div className="mx-auto max-w-7xl px-3 py-2.5 md:px-6" data-id="element-272" data-mp="318s06bjljr9u">
        <div className="hidden items-center justify-center gap-5 text-sm font-medium md:flex" data-id="element-273" data-mp="369fqsw3wy63j">
          <div className="flex items-center gap-2 text-brand-goldLight" data-id="element-274" data-mp="3b7zd4xmf5jwf">
            <ClockIcon className="h-4 w-4" data-id="element-275" data-mp="3b66ea4i1s3yz" />
            <span data-id="element-276" data-mp="1bvwxjygx19o1">PRECIO DE LANZAMIENTO CIERRA EN:</span>
            <span className="rounded bg-white/15 px-2 py-0.5 font-mono font-bold tabular-nums text-white" data-id="element-277" data-mp="1bxhrpmzbiqld">{time}</span>
          </div>
          <span className="h-4 w-px bg-white/25" data-id="element-278" data-mp="27f86rh9ad99g" />
          <span data-id="element-279" data-mp="27g14xtu6iqfz">
            <strong className="text-brand-goldBright" data-id="element-280" data-mp="27gjbbjak2l1m">{spotsTaken}%</strong> de cupos tomados
          </span>
          <a href="#pricing" className="rounded-full bg-brand-goldBright px-3 py-1 text-xs font-bold text-brand-purpleDark transition-colors hover:bg-brand-goldLight" data-id="element-281" data-mp="1xowriyk5jdn9">
            VER PACK →
          </a>
        </div>
        <div className="relative overflow-hidden md:hidden" data-id="element-282" data-mp="2qe3x2hi0x3i0">
          <motion.div className="flex w-max items-center gap-5 whitespace-nowrap text-[11px] font-semibold" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 16,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-283" data-mp="2qbhp4gr80lz9">
            {[0, 1].map(item => <React.Fragment key={item} data-id="element-284" data-mp="2cdjf1njxnbpk">
                <span data-id="element-285" data-mp="14zzlbtt7t7av">
                  ⏰ Cierra en <strong data-id="element-286" data-mp="1510vzx6bjrs2">{time}</strong>
                </span>
                <span data-id="element-287" data-mp="10yw350np2z6h">•</span>
                <span data-id="element-288" data-mp="10xkykymfdneb">
                  <strong className="text-brand-goldBright" data-id="element-289" data-mp="10xcm37u7sk3n">{spotsTaken}%</strong> de cupos tomados
                </span>
                <a href="#pricing" className="rounded-full bg-brand-goldBright px-2.5 py-1 text-brand-purpleDark" data-id="element-290" data-mp="12dyva4hlfion">
                  VER PACK →
                </a>
              </React.Fragment>)}
          </motion.div>
        </div>
      </div>
    </div>;
}